import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BOOKING_URL = 'https://outlook.office.com/bookwithme/user/48e6b21b395043f780bc299577a97fee@wigbers-automation.de?anonymous&ismsaljsauthenabled&ep=plink';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setIsMenuOpen(false); }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === '/' && window.location.hash) {
      setTimeout(() => scrollToSection(window.location.hash.substring(1)), 100);
    }
  }, [location]);

  const navigationItems = [
    { name: 'Projektreferenzen', sectionId: 'referenzen' },
    { name: 'Tech Stack', sectionId: 'stack' },
    { name: 'Leistungen', sectionId: 'pakete' },
    { name: 'Über mich', sectionId: 'ueber-mich' },
    { name: 'FAQ', sectionId: 'faq' },
  ];

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({ top: element.offsetTop - 80, behavior: 'smooth' });
    }
  };

  const handleNav = (item) => {
    scrollToSection(item.sectionId);
    setIsMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-200 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.05)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center hover:opacity-70 transition-opacity" onClick={() => setIsMenuOpen(false)}>
            <img src="/assets/images/wigbers_logo.svg" alt="Wigbers" className="h-8 w-auto" />
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navigationItems.map((item) => (
              <button
                key={item.sectionId}
                onClick={() => handleNav(item)}
                className="px-3.5 py-2 text-[13px] font-medium text-gray-500 hover:text-gray-900 transition-colors"
              >
                {item.name}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center">
            <button
              onClick={() => window.open(BOOKING_URL, '_blank')}
              className="inline-flex items-center gap-2 bg-gray-900 text-white px-5 py-2 text-[13px] font-medium rounded-lg hover:bg-gray-800 transition-colors"
            >
              Termin buchen
            </button>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden flex items-center justify-center w-10 h-10 text-gray-500 hover:text-gray-900 transition-colors"
            aria-label="Menü"
          >
            <Icon name={isMenuOpen ? 'X' : 'Menu'} size={22} />
          </button>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 -mx-6 px-6 pb-6 pt-4 space-y-1">
            {navigationItems.map((item) => (
              <button
                key={item.sectionId}
                onClick={() => handleNav(item)}
                className="w-full text-left px-3 py-2.5 text-[15px] font-medium text-gray-500 hover:text-gray-900 transition-colors"
              >
                {item.name}
              </button>
            ))}
            <div className="pt-4 border-t border-gray-100 mt-2">
              <button
                onClick={() => { setIsMenuOpen(false); window.open(BOOKING_URL, '_blank'); }}
                className="w-full bg-gray-900 text-white px-5 py-3 text-[15px] font-medium rounded-lg hover:bg-gray-800 transition-colors text-center"
              >
                Termin buchen
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
